import React, { useState } from "react";
import { Form, Button, Col, Container, Row } from "react-bootstrap";
import AdvancedAddressesFilters from "../../Addresses/AdvancedAddressesFilters";
import PostcodeInput from "../../Common/PostcodeInput";

const AddressesNewFilters = ({
  onFilterChange,
  onSearch,
  onImmediateFilterChange,
  filters = {},
}) => {
  const [showAdvancedFilters, setShowAdvancedFilters] = useState(false);

  return (
    <Container className="mt-4">
      <Form
        onKeyDown={(e) => {
          if (
            e.key === "Enter" &&
            !["TEXTAREA", "SELECT"].includes(e.target.tagName)
          ) {
            e.preventDefault();
            onSearch?.();
          }
        }}
      >
        <Row className="mb-3">
          <Col md={3}>
            <Form.Group controlId="dateFrom">
              <Form.Label>Data dodania od</Form.Label>
              <Form.Control
                type="date"
                placeholder=""
                value={filters.dateFrom || ""}
                onChange={(e) => onFilterChange("dateFrom", e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group controlId="dateTo">
              <Form.Label>Data dodania do</Form.Label>
              <Form.Control
                type="date"
                placeholder=""
                value={filters.dateTo || ""}
                onChange={(e) => onFilterChange("dateTo", e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group controlId="cityName">
              <Form.Label>Miejscowość</Form.Label>
              <Form.Control
                type="text"
                placeholder=""
                value={filters.cityName || ""}
                onChange={(e) => onFilterChange("cityName", e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group controlId="postcode">
              <Form.Label>Kod pocztowy</Form.Label>
              <PostcodeInput
                value={filters.postcode || ""}
                onChange={(val) => onFilterChange("postcode", val)}
                inputMode="numeric"
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group controlId="streetName">
              <Form.Label>Ulica</Form.Label>
              <Form.Control
                type="text"
                placeholder=""
                value={filters.streetName || ""}
                onChange={(e) => onFilterChange("streetName", e.target.value)}
              />
            </Form.Group>
          </Col>
        </Row>
        <Row className="mb-3">
          <Col md={2} className="d-flex align-items-end">
            <Button
              variant="primary"
              type="button"
              className="w-100"
              style={{ backgroundColor: "#D40511", borderColor: "#D40511" }}
              onClick={() => setShowAdvancedFilters(!showAdvancedFilters)}
            >
              {showAdvancedFilters ? "Podstawowy" : "Zaawansowany"}
            </Button>
          </Col>
        </Row>
        {showAdvancedFilters && (
          <AdvancedAddressesFilters
            onFilterChange={onFilterChange}
            onImmediateFilterChange={onImmediateFilterChange}
            filters={filters}
          />
        )}
      </Form>
    </Container>
  );
};

export default AddressesNewFilters;
